import './bootstrap';
// resources/js/app.tsx
import '../scss/app.scss';
import '../css/brand.css';
import '../css/chat.css';
import 'flatpickr/dist/flatpickr.min.css';

import { InertiaProgress } from '@inertiajs/progress';
InertiaProgress.init({
  color: '#006633',
  delay: 200,
  includeCSS: false,
  showSpinner: false,
});

import AppProvidersWrapper from '@/components/wrappers/AppProvidersWrapper';
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';

const appName = import.meta.env.VITE_APP_NAME;

createInertiaApp({
  title: (title) => (title ? `${title} | ${appName}` : appName),
  resolve: (name) =>
    resolvePageComponent(`./Pages/${name}.tsx`, import.meta.glob('./Pages/**/*.tsx')),
  setup({ el, App, props }) {
    createRoot(el).render(
      <AppProvidersWrapper>
        <App {...props} />
      </AppProvidersWrapper>
    );
  },
});
